import { AllSubjectExtentPage } from './AllSubjectExtentPage';
export default AllSubjectExtentPage;
